import React, { useContext } from 'react';
import styled from 'styled-components';
import { AppContext } from '@prisjakt/ui-app-context';
import { layout } from '@prisjakt/ui-base';
import { TitleMediumText } from '@prisjakt/ui/text/variants';

import { ContentTypes } from '../../types';

type Props = {
  type: ContentTypes;
};

export default function Badge({ type }: Props) {
  const { t } = useContext(AppContext);

  switch (type) {
    case ContentTypes.TEST:
      return <Text>{t('expert', 'test.test')}</Text>;
    case ContentTypes.TOPLIST:
    case ContentTypes.TOPLIST_HEADLINE:
      return <Text>{t('expert', 'toplist.toplist')}</Text>;
    case ContentTypes.GUIDE:
      return <Text>{t('expert', 'guide.guide')}</Text>;

    default:
      return null;
  }
}

export const Text = styled(TitleMediumText)`
  && {
    font-size: ${layout.measurements.fontSizeMedium};
    color: ${p => p.theme.colors.maybeBlue700};
  }
`;
